"use client"

import { getProductName } from "@/utils/product_detail/getProductName"
import { useAppSelector } from "../redux"

export const useProductName = () => {
  const product = useAppSelector(state => state.product.design_detail.data)
  return getProductName(product)
}